module.exports = __webpack_public_path__ + "img/poster_00.ecf1994d.png";